import React from 'react';
import styled from 'styled-components';
import { Headers } from '../../../../view/TextSubHeaders';
import { ProductBox } from './components/ProductBox';
import products1 from '../../../../img/MainPage/ProductsFruits.png';
import products2 from '../../../../img/MainPage/ProductsOils.png';
import products3 from '../../../../img/MainPage/ProductsVegetable.jpeg';
import { Container } from '../../../../view/Containers';

interface Product {
  img: string;
  content: string;
  title: string;
  link?: string;
}

const ProductHeader = styled(Headers)`
  letter-spacing: 0.06em;
  font-size: 40px;
  line-height: 53px;
  font-family: 'Playfair Display', serif;
  font-weight: bold;
  text-align: center;
`;

const ProductListContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  @media screen and (max-width: 1200px) {
    display: block;
    margin: 0 auto;
  }
`;

const productList = [
  {
    img: products1,
    title: 'Przetwory owocowe',
    content: 'W naszym gospodarstwie pola i sad są pełne aromatycznych ekologicznych owoców. To właśnie z nich tworzymy dla was domowe syropy, soki, dżemy, musy, a nawet octy. ',
    link: 'https://www.sklep.owocowo.com.pl/produkty/przetwory-owocowe,2,1288',
  },
  {
    img: products2,
    title: 'Oleje tłoczone',
    content: 'Dbając o szeroki asortyment zdrowej żywności, z ziół i innych roślin tłoczymy dla was oleje roślinne, bogate w NNKT, niefiltrowane i nierafinowane.',
    link: 'https://www.sklep.owocowo.com.pl/produkty/olejarnia,2,1282',
  },
  {
    img: products3,
    title: 'Przetwory warzywne',
    content: 'Z ekologicznych warzyw, które rosną w naszym gospodarstwie przygotowujemy domowe kiszonki, tradycyjne pikle oraz aromatyczne sosy i dania gotowe jak np. leczo.',
    link: 'https://www.sklep.owocowo.com.pl/produkty/przetwory-z-warzyw,2,1284',
  },
];

export function ProductsSection(): JSX.Element {
  return (
    <Container>
      <ProductHeader as="h2">
        Produkty
      </ProductHeader>
      <ProductListContainer>
        {productList.map((product: Product): JSX.Element => (
          <ProductBox
            onClick={(): void => window.location.replace(product.link)}
            key={product.content}
            title={product.title}
            img={product.img}
            content={product.content}
          />
        ))}
      </ProductListContainer>
    </Container>
  );
}
